<template lang="html">
  <transition name="modal-fade">
    <div class="modal-background">

      <div id="location-list-popup" class="white-box col-lg-4 col-md-4 col-sm-6 col-11" role="dialog">
        <header>
          <span id="location-list-close-btn" @click="$emit('close');" tabindex="0"><span class="material-icons grey-text" aria-hidden="true">close</span></span>
          <div class="location-list-headline">
            <h4 v-if="type == 'place'">Vælg et sted</h4>
            <h4 v-if="type == 'address'">Vælg adresse</h4>
          </div>
        </header>

        <section>
          <ul class="location-item-list" v-if="type == 'place'">
            <li v-if="favoriteData.place.length == 0">Du har endnu ikke tilføjet nogen favoritsteder.</li>
            <template v-for="(place, index) in favoritePlaces">
              <li class="pointer" @click="setActive(place, index)" :class="{'selected' : index == activeIndex}" tabindex="0">
                <span class="address-name">
                  {{ place.name }}
                </span>
                <div class="address-name-checkmark"><span class="material-icons grey-text">check</span></div>
              </li>
            </template>
          </ul>

          <ul class="location-item-list" v-if="type == 'address'">
            <li v-if="favoriteData.address.length == 0">Du har endnu ikke tilføjet nogen adresser.</li>
            <template v-for="(address, index) in favoriteData.address">
              <li class="pointer" @click="setActive(address, index)" :class="{'selected' : index == activeIndex}" tabindex="0">
                <span class="address-name" v-if="address.alias">
                  {{ address.alias }}
                  <br>
                  <em class="small">
                    {{ address.name }}
                  </em>
                </span>
                <span class="address-name" v-else>
                  {{ address.name }}
                </span>
                <div class="address-name-checkmark"><span class="material-icons grey-text">check</span></div>
              </li>
            </template>
          </ul>
        </section>

        <footer class="text-center">
          <button class="btn col-6" :class="[activeItem != null ? 'green' : 'dark-grey']" @click="confirmNewPosition();">Vælg</button>
        </footer>
      </div>

    </div>
  </transition>
</template>

<script>
import Profile from '@/assets/profile/Profile.js'

export default {
  data() {
    return {
      favoriteData: {
        'address': [],
        'place': [],
      },
      activeIndex: null,
      activeItem: null,
    }
  },
  computed: {
    favoritePlaces() {
      return this.favoriteData.place.filter(function(item) {
        return !item.itemBroke && !item.archived;
      })
    },
  },
  props: {
    type: {
      required: true,
    }
  },
  created() {
    Profile.getUserData().then((data) => {
      Profile.getLikeData(data.likes).then((finalData) => {
        this.favoriteData = finalData;
      });
    });
  },
  methods: {
    setActive(item, index) {
      this.activeItem = item;
      this.activeIndex = index;
    },
    confirmNewPosition() {
      this.$emit('close');
      this.$emit('dataSelected', this.activeItem);
    },
  }
}
</script>

<style lang="css" scoped>
  #location-list-popup {
    padding: 10px;
  }

  #location-list-close-btn {
    position: absolute;
    height: 30px;
    top: 4px;
    right: 5px;
    cursor: pointer;
  }

  .location-list-headline {
  	text-align: center;
  	border-bottom: 1px solid #ddd;
  }

  .location-item-list {
  	position: relative;
  	max-height: 300px;
  	overflow-y: auto;
  	border-bottom: 1px solid #ddd;
  }

  .location-item-list li {
    display: table;
  	padding: 10px;
    border-bottom: 1px solid #ddd;
    width: 100%;
  }

  .address-name {
    display: table-cell;
    vertical-align: middle;
  }

  .address-name-checkmark {
    display: table-cell;
    vertical-align: middle;
    height: 30px;
    width: 30px;
  }

  .selected {
    color: rgb(000, 143, 73) !important;
  }

  .selected i {
    color: rgb(000, 143, 73) !important;
  }

  footer {
    margin-top: 10px;
  }
</style>
